import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../../../base/models'
import { CommonPostResponse } from '../../../components/models/models'
import { IListOrder, IOrdersAndPayments } from '../models/models'

export class GetOrdersAndPaymentsApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/orderReport/ordersAndPayments',
      requesterInfo,
    })
  }

  public async getOrdersAndPayments(request: IOrdersAndPayments): Promise<IListOrder> {
    return await this.postAsync<IListOrder>(request)
  }
}
